import { matchesPage } from "./matchesPage";
import type { PromoModal } from "./types";

/**
 * The one promo for this page: matching and unsuppressed, page-specific before global,
 * otherwise the order given (most recently updated first).
 */
export function selectPromoModal(
  modals: PromoModal[],
  pathname: string,
  isSuppressed: (modal: PromoModal) => boolean,
): PromoModal | null {
  const candidates = modals.filter(modal => matchesPage(pathname, modal.pagePaths) && !isSuppressed(modal));
  return candidates.find(modal => modal.pagePaths?.length) ?? candidates[0] ?? null;
}
